<template>
  <b-container fluid>
    <b-form @submit.prevent="addHQUser">
      <b-row class="pb-2">
        <b-col sm="4">
          <h3>
            <b-badge variant="primary">
              Add HQ User
            </b-badge>
          </h3>
        </b-col>
        <b-col sm="4" class="pb-2 pb-sm-0" order="3" order-sm="2">
          <b-button
            block
            :disabled="waiting"
            variant="success"
            type="submit">
            Add <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
          </b-button>
        </b-col>
        <b-col sm="4" class="pb-2 pb-sm-0" order="2" order-sm="3">
          <b-button 
            block
            @click="$router.go(-1)">
            Back
          </b-button>
        </b-col>
      </b-row>
      <b-form-group
        class="pt-2"
        id="input-group-name"
        description="name of the HQ user"
        label="Name"
        label-for="input-name"
        label-cols-sm="2">
        <b-form-input
          required
          id="input-name"
          v-model="name"
          type="text"
          placeholder="enter name">
        </b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-cell"
        description="cellphone number"
        label="Cell"
        label-for="input-cell"
        label-cols-sm="2">
        <b-form-input
          required
          id="input-cell"
          v-model="cell"
          type="tel"
          placeholder="enter number">
        </b-form-input>
      </b-form-group>
      <b-form-group
        id="input-group-role"
        description="select AdminHQ, SupportHQ or HQView"
        label="Role"
        label-for="input-role"
        label-cols-sm="2">
        <b-form-select
          required
          id="input-role"
          v-model="role"
          :options="roleOptions">
        </b-form-select>
      </b-form-group>
    </b-form>
  </b-container>
</template>

<script>
import { authService } from '../_services';
export default {
  data() {
    return {
      waiting: false,
      name: '',
      cell: '',
      role: null,
      roleOptions: [
        {value: null, text: 'select a role'},
        {value: 'SupportHQ', text: 'Support HQ'},
        {value: 'AdminHQ', text: 'Admin HQ'},
        {value: 'HQView', text: 'HQ View'},
      ]
    }
  },
  methods: {
    addHQUser() {
      this.waiting = true
      let vm = this
      authService.addHQUser(this.name, this.role, this.cell)
      .then((response) => {
        this.$bvModal.msgBoxOk(response.data)
        vm.waiting = false
      })
      .catch((err) => {
        this.$bvModal.msgBoxOk('Error adding HQ user')
        vm.waiting = false
      })
    }
  },
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/AddHQUserPage.vue